module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container-fluid page-head-wrap"
  }, [_c('div', {
    staticClass: "container page-head"
  }, [_c('h3', {
    staticClass: "h5 text-center"
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[92][1]",
      "isHtml": true
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "offset-md-2 col-md-8 px-md-5"
  }, [_c('page-form')], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-235beab2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/Unsupported.vue
// module id = 678
// module chunks = 0